import React, { useEffect, useState } from "react";
import { Gmail, GmailMobile, Whatsappmobile, Whatsappnew } from "../icons";
import { useMediaQuery } from "react-responsive";
import {
  SendOtp,
  VerifyOtp,
  SendPhoneOTP,
  VerifyPhoneNumberOtp,
} from "../services/btc-api.service";
import { toast } from "react-toastify";
export default function Verification({
  onBack,
  onsubmit,
  RegisterUser,
  personalInfoData,
  handleVerificationInputChange,
}) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [verificationCodegmail, setVerificationCodegmail] = useState("");
  const [verificationCodeSms, setVerificationCodeSms] = useState("");
  const [showTimer, setShowTimer] = useState(true);
  const [attempt, setAttempt] = useState(0);
  const [smsAttempt, setSmsAttempt] = useState(0);

  const [errors, setErrors] = useState({});
  const [seconds, setSeconds] = useState(60);
  const [secondssms, setSecondsSms] = useState(60);

  const [isResendDisabledgmail, setIsResendDisabledgmail] = useState(false);
  const [isResendDisabledSms, setIsResendDisabledSms] = useState(false);

  const [emailSpinner, setEmailSpinner] = useState(false);
  const [smsSpinner, setSmsSpinner] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!personalInfoData.email) newErrors.email = "email is required.";
    if (!personalInfoData.contactNumber)
      newErrors.contactnumber = "contactnumber is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await VerifyOtp({
          email: personalInfoData.email,
          otp: verificationCodegmail,
        });

        const verifyWhatsapp = await VerifyPhoneNumberOtp({
          phoneNumber:
            personalInfoData.selectedCountryCode +
            personalInfoData.contactNumber,
          otp: verificationCodeSms,
        });

        if (response && verifyWhatsapp) {
          return RegisterUser();
        } else {
          toast.error("error in verification");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const handleSendCode = async () => {
    if (personalInfoData.email) {
      setEmailSpinner(true);
      const verificationSent = await sendVerificationCodegmail();
      setEmailSpinner(false);
      if (verificationSent) {
        if (attempt === 0) {
          setAttempt(attempt + 1);
        } else {
          setSeconds(300);
        }
        setIsResendDisabledgmail(true);
        setShowTimer(true);

        const timer = setInterval(() => {
          setSeconds((prevSeconds) => {
            if (prevSeconds > 0) {
              return prevSeconds - 1;
            } else {
              setIsResendDisabledgmail(false);
              clearInterval(timer);
              return 0;
            }
          });
        }, 1000);

        return () => {
          clearInterval(timer);
        };
      }
    } else {
      console.error("Error sending verification code");
    }
  };

  const sendVerificationCodegmail = async () => {
    try {
      const response = await SendOtp({
        email: personalInfoData.email,
      });
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleSendCodesms = async () => {
    if (personalInfoData.contactNumber) {
      setSmsSpinner(true);
      const verificationSentsms = await sendVerificationCodeSms();
      setSmsSpinner(false);

      if (verificationSentsms) {
        if (smsAttempt === 0) {
          setSmsAttempt(smsAttempt + 1);
        } else {
          setSecondsSms(300);
        }
        setIsResendDisabledSms(true);
        const timersms = setInterval(() => {
          setSecondsSms((prevSeconds) => {
            if (prevSeconds > 0) {
              return prevSeconds - 1;
            } else {
              setIsResendDisabledSms(false);
              clearInterval(timersms);
              return 0;
            }
          });
        }, 1000);

        return () => {
          clearInterval(timersms);
        };
      } else {
        console.error("Error sending verification code");
      }
    }
  };
  const sendVerificationCodeSms = async () => {
    try {
      const response = await SendPhoneOTP({
        phoneNumber:
          personalInfoData.selectedCountryCode + personalInfoData.contactNumber,
      });

      return response;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    const middleOfPage = window.innerHeight / 2;
    window.scrollTo(0, middleOfPage);
  }, []);

  return (
    <div className="Verification">
      {isMobile ? (
        <div className="container">
          <p className="heading">Verification</p>
          <div className="d-flex flex-row">
            <div className="gmail-icon-mobile ">
              <GmailMobile />
            </div>
            <div>
              <div className="col-10 col-md-8 inputpadding">
                <input
                  name="email"
                  type="text"
                  disabled
                  placeholder="Luqman@gmail.com"
                  className={`border ${
                    errors.email ? "border-danger" : "border-secondary"
                  } rounded mb-2 form-control`}
                  value={personalInfoData.email}
                  onChange={handleVerificationInputChange}
                />
                {errors.email && <p className="text-danger">{errors.email}</p>}
              </div>
              <div className="col-10 col-md-8 inputpadding">
                <input
                  type="text"
                  placeholder="Enter Code"
                  className="border border-secondary rounded form-control"
                  value={verificationCodegmail}
                  onChange={(e) => setVerificationCodegmail(e.target.value)}
                />

                {showTimer && (
                  <p onClick={!isResendDisabledgmail ? handleSendCode : null} className="spacing2" dis>
                    <span>RE-SEND</span> <span>{seconds} SEC</span>
                  </p>
                )}
              </div>
              <div className="col-6 col-md-6 ">
                <button
                  type="button"
                  className="button1 btn-top"
                  onClick={handleSendCode}
                  disabled={isResendDisabledgmail}
                >
                  {!emailSpinner ? (
                    "Send Code"
                  ) : (
                    <div className="spinning"></div>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex flex-row">
            <div className="sms-icon-mobile ">
              <Whatsappmobile />
            </div>
            <div>
              <div className="col-10 col-md-8 inputpadding">
                <input
                  name="contactNumber"
                  type="text"
                  disabled
                  placeholder="+92 323 8000081"
                  className={`border ${
                    errors.contactnumber ? "border-danger" : "border-secondary"
                  } rounded mb-2 form-control`}
                  value={
                    personalInfoData.selectedCountryCode +
                    personalInfoData.contactNumber
                  }
                  onChange={handleVerificationInputChange}
                />
                {errors.contactnumber && (
                  <p className="text-danger">{errors.contactnumber}</p>
                )}
              </div>
              <div className="col-10 col-md-8 inputpadding">
                <input
                  type="text"
                  placeholder="Enter Code"
                  className="border border-secondary rounded form-control"
                  value={verificationCodeSms}
                  onChange={(e) => setVerificationCodeSms(e.target.value)}
                />
                <p onClick={!isResendDisabledSms ? handleSendCodesms : null} className="spacing">
                  <span>RE-SEND</span> <span>{secondssms} SEC</span>
                </p>
              </div>
              <div className="col-6 col-md-6">
                <button
                  type="button"
                  className="button1 btn-top"
                  onClick={handleSendCodesms}
                  disabled={isResendDisabledSms}
                >
                  {!smsSpinner ? "Send Code" : <div className="spinning"></div>}
                </button>
              </div>
            </div>
          </div>
          <div className="m-2 d-flex justify-content-center">
            <div className="col-4 col-md-6">
              <button type="button" className="buttonstyle4" onClick={onBack}>
                {"<"}&nbsp; Back
              </button>
            </div>
            <div className="col-8 col-md-6 ">
              <button
                type="submit"
                className="buttonstyle6"
                onClick={handleSubmit}
              >
                Register Now
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <p className="heading">Verification</p>
          <div className="row  p-2">
            <div className="col-2 col-md-2 col-lg-2">
              <Gmail className="icon" />
            </div>
            <div className="col-8 col-md-8 col-lg-6">
              <input
                type="text"
                name="email"
                disabled
                placeholder="Luqman@gmail.com"
                className={`border ${
                  errors.email ? "border-danger" : "border-secondary"
                } rounded mb-2 form-control`}
                value={personalInfoData.email}
                onChange={handleVerificationInputChange}
              />
              {errors.email && <p className="text-danger">{errors.email}</p>}
            </div>
            <div className="col-8 col-md-8 col-lg-3">
              <input
                type="text"
                placeholder="Enter Code"
                className="border border-secondary rounded form-control"
                value={verificationCodegmail}
                onChange={(e) => setVerificationCodegmail(e.target.value)}
              />
              {showTimer && (
                <p
                  onClick={!isResendDisabledgmail ? handleSendCode : null}
                  className="spacing2"
                >
                  <span>RE-SEND</span> <span>{seconds} SEC</span>
                </p>
              )}
            </div>
            <div className="col-6 col-md-6 col-lg-4">
              <button
                type="button"
                className="button1 btn-top"
                onClick={handleSendCode}
                disabled={isResendDisabledgmail}
              >
                {!emailSpinner ? "Send Code" : <div className="spinning"></div>}
              </button>
            </div>
          </div>
          <div className="row p-2 ">
            <div className="col-2 col-md-2 col-lg-2">
              <Whatsappnew className="sms-icon" />
            </div>
            <div className="col-6 col-md-8 col-lg-6">
              <input
                disabled
                name="contactNumber"
                type="text"
                placeholder="+92 323 8000081"
                className={`border ${
                  errors.contactnumber ? "border-danger" : "border-secondary"
                } rounded mb-2 form-control`}
                value={
                  personalInfoData.selectedCountryCode +
                  personalInfoData.contactNumber
                }
                onChange={handleVerificationInputChange}
              />
              {errors.contactnumber && (
                <p className="text-danger">{errors.contactnumber}</p>
              )}
            </div>
            <div className="col-6 col-md-8 col-lg-3">
              <input
                type="text"
                placeholder="Enter Code"
                className="border border-secondary rounded form-control"
                value={verificationCodeSms}
                onChange={(e) => setVerificationCodeSms(e.target.value)}
              />
              <p
                onClick={!isResendDisabledSms ? handleSendCodesms : null}
                className="spacing2"
              >
                <span>RE-SEND</span> <span>{secondssms} SEC</span>
              </p>
            </div>
            <div className="col-6 col-md-6 col-lg-4">
              <button
                type="button"
                className="button1 btn-top"
                onClick={handleSendCodesms}
                disabled={isResendDisabledSms}
              >
                {!smsSpinner ? "Send Code" : <div className="spinning"></div>}
              </button>
            </div>
          </div>
          <div className="m-2 d-flex justify-content-center">
            <div className="col-6 col-md-10 col-lg-4">
              <button type="button" className="buttonstyle4" onClick={onBack}>
                {"<"}&nbsp; Back
              </button>
            </div>
            <div className="col-8 col-md-10 col-lg-6">
              <button
                type="submit"
                className="buttonstyle6"
                onClick={handleSubmit}
              >
                Register Now
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
